export default __webpack_public_path__ + "img/InterDisplay-Medium_89df546.woff2";